// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from './application'

import AutoSubmitController from './auto_submit_controller'
application.register('auto-submit', AutoSubmitController)

import Bridge__MenuController from './bridge/menu_controller'
application.register('bridge--menu', Bridge__MenuController)

import Bridge__NotificationTokenController from './bridge/notification_token_controller'
application.register(
  'bridge--notification-token',
  Bridge__NotificationTokenController
)
import DatatableController from "./datatable_controller";
application.register("datatable", DatatableController);

import Bridge__ReviewPromptController from './bridge/review_prompt_controller'
application.register('bridge--review-prompt', Bridge__ReviewPromptController)

import BulkSelectController from './bulk_select_controller'
application.register('bulk-select', BulkSelectController)

import ConfirmableToggleController from './confirmable_toggle_controller'
application.register('confirmable-toggle', ConfirmableToggleController)

import ConfirmableSubmitController from './confirmable_submit_controller'
application.register('confirmable-submit', ConfirmableSubmitController)

import ConnectionCheckController from './connection_check_controller'
application.register('connection-check', ConnectionCheckController)

import FlatpickrController from './flatpickr_controller'
application.register('flatpickr', FlatpickrController)

import MaskController from './mask_controller'
application.register('mask', MaskController)

import ModalController from './modal_controller'
application.register('modal', ModalController)

import OffcanvasController from './offcanvas_controller'
application.register('offcanvas', OffcanvasController)

import PasswordController from './password_controller'
application.register('password', PasswordController)

import PopoverController from './popover_controller'
application.register('popover', PopoverController)

import ScrollController from './scroll_controller'
application.register('scroll', ScrollController)

import SwiperController from './swiper_controller'
application.register('swiper', SwiperController)

import ThemeController from './theme_controller'
application.register('theme', ThemeController)

import ToastController from './toast_controller'
application.register('toast', ToastController)

import ToastTriggerController from './toast_trigger_controller'
application.register('toast-trigger', ToastTriggerController)

import TooltipController from './tooltip_controller'
application.register('tooltip', TooltipController)

import TurboModalController from './turbo_modal_controller'
application.register('turbo-modal', TurboModalController)

import RailsNestedForm from '@stimulus-components/rails-nested-form'
application.register('nested-form', RailsNestedForm)

import NotificationHideController from './notification_hide_controller'
application.register('notification-hide', NotificationHideController)

import SelectAllController from './select_all_controller'
application.register('select-all', SelectAllController)

import NotificationController from './notification_controller'
application.register('notification', NotificationController)

import RankedVoteController from './ranked_vote_controller'
application.register('ranked-vote', RankedVoteController)

import TrixNoAttachmentsController from './trix_no_attachments_controller'
application.register('trix-no-attachments', TrixNoAttachmentsController)

import ChecklistFilterController from './checklist_filter_controller'
application.register('checklist-filter', ChecklistFilterController)
import TagSelectController from './tag_select_controller'
application.register('tag-select', TagSelectController)
